import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import { SET_DOCUMENT_JOURNAL_LIST, SET_DOCUMENT_JOURNAL_BY_ID, SET_DOCUMENT_JOURNAL_LOADING, } from "./types";

const buildDocumentJournalPayload = (data) => ({
  mid: data.mid,
  dtype: data.dtype ?? 0,
  ddate: data.ddate,
  dseries: data.dseries || '',
  dnum: data.dnum || '',
  dtext: data.dtext || '',
})


export const getDocumentJournalList = (params) => async (dispatch, getState) => {
  try {
    const clean = Object.fromEntries(
      Object.entries(params || {}).filter(([, v]) => v !== '' && v !== undefined && v !== null)
    );
    const urlParams = new URLSearchParams(clean).toString();
    dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: true });
    const { data } = await api.get(`/documents_journal?${urlParams}`);
    dispatch({ type: SET_DOCUMENT_JOURNAL_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: false });
  }
}
export const getDocumentJournal = (xp_key) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: true });
    const { data } = await api.get(`/documents_journal/${xp_key}`);
    dispatch({ type: SET_DOCUMENT_JOURNAL_BY_ID, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: false });
  }
}

export const createDocumentJournal = (data, params) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: true });
    await api.post(`/documents_journal`, buildDocumentJournalPayload(data));
    await dispatch(getDocumentJournalList(params))
    success = true
  } catch (ERR) {
    createNotification('error', ERR?.response?.data?.error || ERR?.response?.data?.message)
  } finally {
    dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: false });
    return success
  }
}
export const updateDocumentJournal = (data, params) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: true });
    await api.put(`/documents_journal/${data.xp_key}`, buildDocumentJournalPayload(data));
    await dispatch(getDocumentJournalList(params))
    success = true
  } catch (ERR) {
    createNotification('error', ERR?.response?.data?.error || ERR?.response?.data?.message)
  } finally {
    dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: false });
    return success
  }
}


export const deleteDocumentJournal = (id, params) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: true });
    await api.delete(`/documents_journal/${id}`);
    await dispatch(getDocumentJournalList(params))
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: false });
  }
}